import React from 'react';

import * as cr from './_cr';
import * as ht from './_ht';

import * as ica from 'src/ica';

import * as BoxC from './_ccbBoxC';
import * as TextC from './_ccbTextC';

export const N = React.memo((pd: ht.linkCz) => {

  const _abtType = pd.abtType ?? 'nmlz';
  const _abtz = ica.linkAbtz[_abtType] ? ica.linkAbtz[_abtType]() : {};

  return (
    cr.c(BoxC.N, {
      key: 'Link.root',
      boxStlz: {
        ... _abtz.boxStlz,
        ... pd.boxStlz
      },
      oClds: [

        pd.bfrCz ?
        cr.c(TextC.N, {
          key: -10,
          textz: {
            ...pd.bfrCz.textz,
            stlz: {
              ..._abtz.bfrCz?.textz?.stlz,
              ...pd.bfrCz?.textz?.stlz,
            },
          },
          boxzStlz: {
            ..._abtz.bfrzCz?.boxStlz,
            ...pd.bfrCz?.boxStlz,
          }
        })
        : null,

        cr.c(TextC.N, {
          key: -20,
          textz: {
            ... pd.linkCz.textz,
            stlz: {
              ... _abtz.linkCz?.textz?.stlz,
              ... pd.linkCz?.textz?.stlz,
            },
            ptyz: {
              ... _abtz.linkCz?.textz?.ptyz,
              ... pd.linkCz?.textz?.ptyz,
            },
          },
          boxStlz: {
            ... _abtz.linkCz?.boxStlz,
            ... pd.linkCz?.boxStlz,
          },
          pslStlz: {
            ... pd.pslStlz,
          },
          pslPtyz: {
            onPress:
              pd.cz.onPrs ?
                pd.cz.onPrs
              : pd.cz.url ?
              () => {
                cr.openUrl({
                  url: pd.cz.url, 
                  tgt: pd.cz.tgt
                });
              }
              : undefined,
          },
        }),

        pd.atrCz ?
        cr.c(TextC.N, {
          key: -30,
          textz: {
            ... pd.atrCz.textz,
            stlz: {
              ... _abtz.atrCz?.textz.textStlz,
              ... pd.atrCz?.textz.stlz,
            },
          },
          boxStlz: {
            ... _abtz.atrCz?.boxStlz,
            ... pd.atrCz?.boxStlz,
          }
        })
        : null,

      ],
    })
  );
});
